<clr-file-input-container clrButtonLabel="Datei auswählen">
  <!--<label>{{ label }}</label>-->
  <input
    clrFileInput
    type="file"
    accept=".pdf,.doc,.docx,.xls,.xlsx,.dwg,.stp,.step"
    [attr.aria-label]="label"
    #fileInput />
  <clr-control-helper><app-progress [progress]="progress"></app-progress></clr-control-helper>
  <clr-control-success>Success message</clr-control-success>
  <clr-control-error>{{ errorMessage }}</clr-control-error>
</clr-file-input-container>
